import { App, Button, Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { downloadApplications, handleDownload } from '../../common/Utilities';

const CaseSummaryInfo = ({ pdfurl }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const AppId = location?.pathname.slice(19, 200);

    useEffect(() => {
        if (AppId !== undefined && AppId != null) {
            navigate('/case-detail', { state: { Id: AppId, pagePermission: {} } });

        }
    }, [AppId])



    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-hidden">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Case Summary InFo</p>
                        </div>
                    </Col>
                </Row >
            </div >

        </div >
    );
};

export default CaseSummaryInfo;